
//var interval = setInterval(ticker,1000)
position = 0
var flickerOn = true
var swapOn = true
acting = true

var text = {
    1: 'Vision problems are the most common early signs of MS – from temporary loss of vision',
    2: 'and colour blindness,',
    3: 'to seeing flashes of light.',
    4: 'Other problems can also include double vision',
    5: 'and involuntary eye movements – which can make it seem like objects are jumping around.'
}
var words = {}
for (var i in text) {
    words[i] = text[i].split(' ')
}
console.log(words)
loadWords(true)

function revealWords(exp) {
    $('.experience-' + exp + ' .word').each(function (i) {
        var self = this
        setTimeout(function () {
            $(self).removeClass('before')
        }, i * 50)
    })
}

var fx = [
    {
        after: 10,
        do: function () {
            console.log('start vision')
            $('.experience .word').addClass('before')

        }
    },
    {
        after: 400,
        do: function () {


            revealWords(1)
        }
    },
    {
        after: 3000,
        do: function () {
            flickerOn = true
            flickerTimeout()
        }
    },
    {
        after: 4000,
        do: function () {
            flickerOn = false
        }
    },
    {
        after: 1000,
        do: function () {
            $('.flickered').removeClass('flickered')
        }
    },
    {
        after: 175,
        do: function () {
//            $('.experience-2 .word').removeClass('before')
            revealWords(2)
        }
    },
    {
        after: 800,
        do: function () {
            $('body').addClass('grayed')
        }
    },
    {
        after: 1200,
        do: function () {
//            $('.experience-3 .word').removeClass('before')
            revealWords(3)
        }
    },
    {
      after: 1100,
      do: function () {
          $('.flasher').show().addClass('flash').delay(200).queue(function (next) {
              $('body').removeClass('grayed')
              $(this).fadeOut(3200, function () {
                  $(this).removeClass('flash')
              })

              next()
          })
      }
  },
  {
      after: 3500,
      do: function () {
          $('.flasher').show().addClass('flash').delay(200).queue(function (next) {
              $(this).fadeOut(3000, function () {
                  $(this).removeClass('flash')
                })
                next()
            })
        }
    },
//    {
//        after:1000,
//        do:function(){
//            $('body').removeClass('grayed')
//        }
//    },
    {
        after: 4500,
        do: function () {
//            $('.experience-4 .word').removeClass('before')
            revealWords(4)
        }
    },
    {
        after: 1300,
        do: function () {
            $('.doublable').addClass('doubled')

        }
    },
    {
        after: 900,
        do: function () {
            $('.doublable').removeClass('doubled')
        }
    },
    {
        after: 600,
        do: function () {
            $('.doublable').addClass('doubled-back')

        }
    },
    {
        after: 800,
        do: function () {
            $('.doublable').removeClass('doubled-back')
        }
    },
    {
        after: 500,
        do: function () {
//            $('.experience-5 .word').removeClass('before')
            revealWords(5)
        }
    },
    {
        after: 2400,
        do: function () {
            $('.content-bar').addClass('jump-up').delay(200).queue(function (next) {
                $(this).removeClass('jump-up')
                next()
            }).delay(500).queue(function (next) {
                $(this).addClass('jump-up')
                next()
            }).delay(400).queue(function (next) {
                $(this).removeClass('jump-up')
                next()
            }).delay(1500).queue(function (next) {
                $(this).addClass('jump-down')
                next()
            }).delay(300).queue(function (next) {
                $(this).removeClass('jump-down')
                next()
            })
        }
    },
    {
        after: 1000,
        do: function () {
            swapOn = true
            swapTimeout()
            jumpTimeout()
        }
    },
    {
        after: 2500,
        do: function () {
            $('.glitch1').removeClass('hidden')
                    .delay(600).queue(function (next) {
                $(this).addClass('hidden')
                next()
            })
        }
    },
    {
        after: 800,
        do: function () {
            $('.glitch2').removeClass('hidden')
                    .delay(400).queue(function (next) {
                $(this).addClass('hidden')
                next()
            })
        }
    },
    {
        after: 800,
        do: function () {
            $('.glitch3').removeClass('hidden')
                    .delay(4000).queue(function (next) {
                $(this).fadeOut(5000, function () {
                    $(this).addClass('hidden')
                })
                next()
            })
        }
    },

    {
        after: 7000,
        do: function () {
            swapOn = false
            jumpOffTimeout()
        }
    },
    {
        after: 2000,
        do: function () {

            loadWords(false)

        }
    },
    {
        after: 10,
        do: function () {
            console.log('finished vision')
            finishedVision()

        }
    }
]

var fxCog = [
    {
        after: 10,
        do: function () {
            console.log('starting cognitive')
        }
    },
    {
        after: 1000,
        do: function () {
            blurInOutOn = true
            blurInOutTimeout()
        }
    },
    {
        after: 9000,
        do: function () {
            blurInOutOn = false
            blurOutTimeout()
//           blurInTimeout()
        }
    },
    {
        after: 9500,
        do: function () {
            finishedCog()
        }
    }
]



function blurInTimeout() {
    var delay = Math.random() * 500 + 100

    randomOne($('.unblurred .blurred')).removeClass('blurred')
    if ($('.unblurred span.blurred').length) {
        setTimeout(blurInTimeout, delay)
    } else {
        setTimeout(function () {
            $('.blurred').removeClass('blurred')
        }, 3000)
    }

}


function blurOutTimeout() {
    var delay = Math.random() * 500 + 100

    randomOne($('.blurrable').not('.unblurred').find('span').not('.blurred')).addClass('blurred')
    if ($('.blurrable').not('.unblurred').find('span').not('.blurred').length < 6) {
        blurInTimeout()
    }

    if ($('.blurrable').not('.unblurred').find('span').not('.blurred').length) {
        setTimeout(blurOutTimeout, delay)
    }

}

var blurInOutOn = false
function blurInOutTimeout() {
    var delay = Math.random() * 300

    randomOne($('.blurrable span')).toggleClass('blurred')

    if (blurInOutOn) {
        setTimeout(blurInOutTimeout, delay)
    }

}

function loadWords(hidden) {
    $('.experience').html('')
    for (var exp in words) {
        var $expSpan = $('.experience-' + exp)
        for (var i in words[exp]) {
            var $wordSpan = $('<span></span>', {class: (hidden ? 'before' : '') + ' word word-' + i})
            $wordSpan.text(words[exp][i] + ' ')
            $expSpan.append($wordSpan)
        }

    }
}

function jumpOffTimeout() {
    var delay = Math.random() * 500 + 1000
    randomOne($('.jump-left,.jump-right')).each(function (e) {
        $(this).removeClass('jump-left jump-right')
    })

    if ($('.jump-left,.jump-right').length) {
        setTimeout(jumpOffTimeout, delay)
    }
}

function jumpTimeout() {
    var delay = Math.random() * 500 + 1000
    randomOne($('.experience')).each(function (e) {
        var trans = [
            'jump-left',
            'jump-right'
        ]
        $(this).toggleClass(randomString(trans))
    })

    if (swapOn) {
        setTimeout(jumpTimeout, delay)
    }
}

function swapTimeout() {
    var delay = Math.random() * 500 + 500
    randomOne($('.experience')).each(function (e) {
        var words = $(this).text().split(' ')
//        console.log(words)
        var x = Math.floor(Math.random() * words.length);

        var b = words[x];
        words[x] = words[x + 1]
        words[x + 1] = b


        $(this).text(words.join(' '))
    })

    if (swapOn) {
        setTimeout(swapTimeout, delay)
    }
}


function flickerTimeout() {
    var delay = Math.random() * 1000 + 500
    var $flickerables = $('.word').not('.before')
    var $flickered = $flickerables.filter('.flickered')
    if ($flickered.length > 3) {
        var $one = randomOne($flickered)
        $one.removeClass('flickered')
    } else {
        var $one = randomOne($flickerables)
        $one.toggleClass('flickered')
    }

    if (flickerOn) {
        setTimeout(flickerTimeout, delay)
    }

}

function randomOne($things) {
    return $things.eq(Math.floor(Math.random() * $things.length))
}
function randomString(strings) {
    return strings[(Math.floor(Math.random() * strings.length))]
}
function finishedVision() {
    canStartVision = false
    startedVision = false
    canStartCog = true
    attemptStartCognitive()

}
var isFinishedCog = false

function finishedCog() {
    startedCog = false
    canStartCog = false

}

var skipTo = 0
var startedVision = false
var canStartVision = true
function startVision() {
    if (!confirmed) {
        return
    }
    if (startedVision) {
        return
    }
    if (!canStartVision) {
        return
    }
    if (startedCog) {
        return
    }
    startedVision = true

    var total = 0
    for (var i = 0; i < fx.length; i++) {
        if (i >= skipTo) {
            setTimeout(fx[i].do, fx[i].after + total)
            total += fx[i].after
        }

    }
}

var canStartCog = false
var startedCog = false

function startCog() {
//    console.log('startCog',confirmed,canStartCog,startedCog)
    if (!confirmed) {
        return
    }
    if (!canStartCog) {
        return
    }
    if (startedCog) {
        return
    }
    startedCog = true

    var total = 0
    for (var i = 0; i < fxCog.length; i++) {
        if (i >= skipTo) {
            setTimeout(fxCog[i].do, fxCog[i].after + total)
            total += fxCog[i].after
        }

    }
}
//function startCog2(){
//
//    var total = 0
//    for (var i = 0; i < fxCog.length; i++) {
//        if (i >= skipTo) {
//            setTimeout(fxCog[i].do, fxCog[i].after + total)
//            total += fxCog[i].after
//        }
//
//    }
//}
//startCog2()

var offset = 200

$(document).ready(function (e) {
    $(window).scroll(function () {
        $('#section-vision').each(function () {
            var pos = $(this).offset().top;

            var loc = $(document).scrollTop() + ($(window).height() / 2) - offset;
//            console.log('attemptStartVision',pos < loc,pos , loc)
            if (pos < loc) {
                startVision()
            }
            if (pos > loc && !canStartVision) {
                canStartVision = true
            }
        });
        attemptStartCognitive()



    });
})

function attemptStartCognitive() {

    $('#section-cognitive').each(function () {
        var pos = $(this).offset().top;

        var loc = $(document).scrollTop() + ($(window).height() / 2);
//             console.log('attemptStartCognitive',pos < loc,pos , loc)
        if (pos < loc) {
            startCog()
        }

    });
}
